/* unplugin-vue-components disabled */import { render } from "./ai-chat.vue?vue&type=template&id=3855c84b&scoped=true"
import script from "./ai-chat.vue?vue&type=script&lang=js"
export * from "./ai-chat.vue?vue&type=script&lang=js"

import "./ai-chat.vue?vue&type=style&index=0&id=3855c84b&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3855c84b"],['__file',"src/components/ai-chat/ai-chat.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3855c84b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3855c84b', __exports__)) {
    api.reload('3855c84b', __exports__)
  }
  
  module.hot.accept("./ai-chat.vue?vue&type=template&id=3855c84b&scoped=true", () => {
    api.rerender('3855c84b', render)
  })

}


export default __exports__